import React, { useState, useEffect } from "react";
import "../../styles/essay.css";

const Essay = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [scrollPosition, setScrollPosition] = useState({ top: 0, left: 0 });
  const [katuraiimages, setKatturaigal] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const zoomIn = (e) => {
    e.stopPropagation();
    const newZoom = Math.min(zoomLevel + 0.25, 3);
    setZoomLevel(newZoom);

    // Reset scroll position when zooming in
    const container = document.querySelector(".fullscreen-image-container");
    if (container) {
      container.scrollTop = 0;
      container.scrollLeft = 0;
    }
  };

  const zoomOut = (e) => {
    e.stopPropagation();
    setZoomLevel(Math.max(zoomLevel - 0.25, 1));
  };

  const handleScroll = (e) => {
    setScrollPosition({
      top: e.target.scrollTop,
      left: e.target.scrollLeft
    });
  };

  const openImage = (img) => {
    setSelectedImage(img);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/home.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        if (data.katuraiimages) {
          setKatturaigal(data.katuraiimages);
        } else {
          throw new Error("portfolioData not found in response");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="gallery-container">
      <h1 className="publication-title">கட்டுரைகள்</h1>
      <div className="image-grid1">
        {katuraiimages.map((img, index) => (
          <div
            key={index}
            className="image-item"
            onClick={() => openImage(img)}
          >
            <img src={img} alt={`Gallery item ${index + 1}`} loading="lazy" />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="fullscreen-overlay" onClick={closeImage}>
          <div
            className="fullscreen-image-container"
            onClick={(e) => e.stopPropagation()}
            onScroll={handleScroll}
            style={{ overflow: zoomLevel > 1 ? "scroll" : "hidden" }}
          >
            <img
              src={selectedImage}
              alt="Full screen"
              style={{
                transform: `scale(${zoomLevel})`,
                transformOrigin: "top left",
                width: "100%",
                height: "auto"
              }}
            />
          </div>
          <button className="close-button" onClick={closeImage}>
            ×
          </button>
          <div className="zoom-controls">
            <button className="zoom-button" onClick={zoomIn}>
              +
            </button>
            <button className="zoom-button" onClick={zoomOut}>
              -
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Essay;
